import React, { useEffect, useState } from "react";
import axios from "axios";
import * as API from "../../Endpoints/Endpoints";
import { useNavigate, useParams } from "react-router-dom";

const UpdateNetwork = () => {
  const [formData, setFormData] = useState({
    subtype: "",
    subname: "",
    currency: "",
    description: "",
    level1: "",
    level2: "",
    level3: "",
    level4: "",
  });

  const navigate = useNavigate();
  const { netid } = useParams(); 

  useEffect(() => {
    fetchNetworkData();
  }, []);

  const fetchNetworkData = () => {
    const url = API.GET_NETWORK_BYID(netid); 
    console.log("Fetching data from URL:", url);
  
    axios({
      url,
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        setFormData(response.data);
      })
      .catch((error) => {
        alert("Error fetching network data: " + error.message);
      });
  };
  

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    axios
      .put(API.PUT_NETWORK_API(netid), formData, {
        headers: { "Content-Type": "application/json" },
      })
      .then((response) => {
        alert("Network updated successfully!");
        navigate("/networktable"); 
      })
      .catch((error) => {
        alert("Error updating network: " + error.message);
      });
  };

  const goBack = () => {
    navigate("/networktable");
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
      <div className="mt-4 w-full max-w-md p-8 bg-white rounded-lg shadow-lg">
        <h2 className="text-2xl font-bold text-center text-gray-700 mb-6">
          Update Subscription
        </h2>
        <form onSubmit={handleSubmit}>
          {[
            { id: "subtype", label: "Subscription Type", placeholder: "Enter subscription type" },
            { id: "subname", label: "Subscription Name", placeholder: "Enter subscription name" },
            { id: "currency", label: "Currency", placeholder: "Enter currency" },
            { id: "description", label: "Description", placeholder: "Enter description" },
            { id: "level1", label: "Level 1", placeholder: "Enter level 1" },
            { id: "level2", label: "Level 2", placeholder: "Enter level 2" },
            { id: "level3", label: "Level 3", placeholder: "Enter level 3" },
            { id: "level4", label: "Level 4", placeholder: "Enter level 4" },
          ].map(({ id, label, placeholder }) => (
            <div className="mb-4" key={id}>
              <label htmlFor={id} className="block text-sm font-medium text-gray-700 mb-1">
                {label}
              </label>
              <input
                type="text"
                id={id}
                name={id}
                value={formData[id] || ""}
                onChange={handleChange}
                placeholder={placeholder}
                className="w-full px-4 py-2 border rounded-lg focus:ring focus:ring-[#e64a32] focus:outline-none"
                required
              />
            </div>
          ))}
          <div className="flex items-center justify-between">
            <button
              type="submit"
              className="w-full bg-[#e64a32] text-white py-2 px-2 rounded-lg hover:bg-[#d43d2a] focus:outline-none"
            >
              Update
            </button>
            <button
              type="button"
              onClick={goBack}
              className="w-full mt-4 bg-gray-300 text-black py-2 px-2 rounded-lg hover:bg-gray-400 focus:outline-none"
            >
              Go Back
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default UpdateNetwork;
